import { motion } from "framer-motion";
import { PROCESS_STEPS } from "../../lib/constants";

export const Process = () => {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative py-24 md:py-32 bg-[#05070F] overflow-hidden"
    >
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(61,192,175,0.15),transparent_60%)]" />
        <div className="absolute inset-0 tb-grid-dense opacity-30" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-5">
            <div className="text-[11px] tracking-[0.3em] uppercase text-[#3DC0AF] font-mono font-bold">
              / PROCESS
            </div>
            <h2 className="mt-4 text-4xl sm:text-5xl lg:text-6xl font-display font-black tracking-tighter leading-[0.95]">
              Five deliberate steps. Zero surprises.
            </h2>
            <p className="mt-6 text-zinc-400 text-base leading-relaxed max-w-lg">
              Every engagement follows a repeatable, documented workflow — so you
              know exactly what to expect from first call to final delivery.
            </p>
          </div>

          <div className="lg:col-span-7">
            <ol className="relative border-l border-white/10 pl-8 md:pl-10 space-y-10">
              {PROCESS_STEPS.map((step, i) => (
                <motion.li
                  key={step.n}
                  data-testid={`process-step-${i}`}
                  initial={{ opacity: 0, x: 20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.55, delay: i * 0.1 }}
                  className="relative"
                >
                  <span className="absolute -left-[41px] md:-left-[49px] top-0.5 flex h-5 w-5 items-center justify-center">
                    <span className="absolute h-5 w-5 rounded-full bg-[#3DC0AF]/20" />
                    <span className="relative h-2.5 w-2.5 rounded-full bg-[#3DC0AF] shadow-[0_0_0_4px_rgba(61,192,175,0.2)]" />
                  </span>
                  <div className="flex items-baseline gap-4">
                    <span className="font-mono text-xs tracking-[0.25em] text-zinc-500">
                      STEP {step.n}
                    </span>
                    <h3 className="text-xl md:text-2xl font-display font-bold">
                      {step.title}
                    </h3>
                  </div>
                  <p className="mt-2 text-zinc-400 max-w-xl leading-relaxed">
                    {step.desc}
                  </p>
                </motion.li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
};
